import { Component } from '@angular/core';
import { UserMessageService } from './user-message.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

/*
 * dashboard-template-link is the connection to all custom template components.  It's functions include:
 *	- establishing a connection to the different services
 *	- define how a custom template link in the menu should look/behave
 */
		// <a role="button" (click)="goToRouterLink('/dashboardTemplate//-999?id={{id}}')" class="dashboard-template" title="Display dashboard template {{htmlElementLabel}}">{{htmlElementLabel}}</a>

@Component({
	selector: 'dashboard-template-link',
	template: `
		<a role="button" (click)="goToRouterLink()" class="dashboard-template" title="Display dashboard template {{htmlElementLabel}}">{{htmlElementLabel}}</a>
		`,
	styleUrls: ['app.component.css', 'dashboard-template-link.component.css']
})

export class DashboardTemplateLinkComponent {
	userMessageService: UserMessageService;

	htmlElementLabel = 'Label not specified';
	id = 'MustBeUnique';

	constructor (userMessageService: UserMessageService, private router: Router, private location: Location ) {
		this.userMessageService = userMessageService;

	}

	setData ( someData: any ) {
		if ( someData.hasOwnProperty('label')) {
			this.htmlElementLabel = someData.label;
		}
		if ( someData.hasOwnProperty('id')) {
			this.id = someData.id;
		}
	}

	goToRouterLink() {
		const link = ['/dashboardTemplate//-999'];
		const tree = this.router.parseUrl(this.location.path());
		tree.queryParams['id'] = this.id;
		console.log(link, tree.queryParams)
		this.router.navigate(link, { queryParams: tree.queryParams});
	}


	// verifyTemplateCofiguration is passed a list of attributes required for the current template.
	// If any of those attributes is null, a warning is added to userMessageServices' log.
	verifyTemplateConfiguration ( className: string, attributes: string[] ) {

		let problemFound = false;
		const message = {};
		const items: any[] = [];

		console.log('In verifyTemplateConfiguration');
		attributes.forEach(function(element) {
			// console.log(element);
			// console.log(this[element]);
			if ( this[element] === undefined ) {
				if ( !problemFound ) {
					// first time a problem was found
					problemFound = true;

					const line_i = {
						'html': 'h3',
						'message': 'Problem found in the configuration file for class ' + className + '(' + this.label + ')'
					};
					items.push ( line_i );
				}

				const line = {
					'html': 'p',
					'message': ('\u2718' + element + ', a required attribute for this class, is not specified.')
				};
				items.push ( line );

				message['error'] = items;


			}
		}, this);

		if ( problemFound ) {
			// this.userMessageService.log('\u2718' + element);
			this.userMessageService.log(message);
		}
	}

}
